import axios from "axios";

const AttivitaStore={
    state:()=>({
        attivitaSenzaLavoro:[],
        loadedSenzaLavoro:false,
        loaded:false,
        attivita:[]
    }),
    mutations:{

        attivitaSenzaLavoroCaricate(state, item){
            let attivita=[]
            // item.forEach((att)=>{
            //     if(att.id_ticket_padre>0){
            //         attivita.push(att)
            //     }
            // });
            state.attivitaSenzaLavoro=[...item];
            state.loadedSenzaLavoro=true;
            return item;
        },

        attivitaLavoroCaricate(state, item){
            return item;
        },
        ticketChiuso(state, item){
          return item;
        },
        tutteLeAttivitaCaricate(state, item){
            // item.forEach((att)=>{
            //     if(att.id_ticket_first_padre>0){
            //         state.attivita.push(att)
            //     }else{
            //         state.attivitaSenzaLavoro.push(att)
            //     }
            // });
            state.attivita=[...item];
            state.loaded=true;
            return item;
        },
        attivitaUtenteLoaded(state, item){
            return item;
        },
        categorieTicketLoaded(state, item){
            return item;
        },
        creaAttivita(state, item){
            return item;
        },
        ticketCaricato(state, item){
            return item;
        },
        lavoroCaricato(state, item){
            return item;
        },

        // tasksCreated(state, item){
        //     if(item.tsCreato.idTicketParent>0){
        //         let attivitaTS=state.attivita.filter(att=>att.id_ticket===item.tsCreato.idTicket);
        //         if(attivitaTS.length>0){
        //             item.tsCreato.titoloAttivita=attivitaTS[0]?.titolo;
        //         }
        //     }else{
        //         let attivitaTS=state.attivitaSenzaLavoro.filter(att=>att.id_ticket===item.tsCreato.idTicket);
        //         if(attivitaTS.length>0){
        //             item.tsCreato.titoloAttivita=attivitaTS[0]?.titolo;
        //         }
        //     }
        //     this.commit("taskLoadedPM", [...item.tuttiTS])
        //     this.commit("tasksLoaded", item.tuttiTS)
        // }
        attivitaCreata(state, item){
            let index=state.attivita.findIndex(att=>att.id_ticket===item.id_ticket)
            if(index<0){
                state.attivita.push(item)
            }
            return item;
        },
        timbratureCaricate(state, item){
            let timbrature=item.sort((a,b)=>{
                return new Date(b.data) - new Date(a.data);
            })
            return item;
        }
    },
    actions: {


        async loadTicket({commit},data){
                try{
                    const config = {
                        headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                    };
                    commit("showMiniLoader");
                    axios.get(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getDettaglioTicket/"+data.idTicket,{...config})
                        .then(response=>{
                            commit("hideMiniLoader");
                            if(response.data.responseCode!==200){
                                throw new Error(response.data.dettagli)
                            }
                            commit("hideMiniLoader");
                            if(data.isLavoro){
                                commit("lavoroCaricato", response.data.resultObj);
                            }else{
                                commit("ticketCaricato", response.data.resultObj);
                            }
                        }).catch((ex)=>{
                            commit("hideMiniLoader");
                            commit('addMessage', {
                                message:"VUEX getDettaglioTicket error: "+ex.message,
                                messageType:'error'
                            });
                    });

                }catch(e){
                    commit("hideLoader");
                    commit('addMessage', {
                        message:"VUEX getDettaglioTicket error: "+e.message,
                        messageType:'error'
                    });
                }

        },
        async getTimbratureTicket({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getTimbratureTicket", {
                    ...data
                },{...config})
                    .then(response=>{
                        commit("hideMiniLoader");
                        if(response.data.responseCode!==200){
                            throw new Error(response.data.dettagli)
                        }
                        let timbrature=JSON.parse(response.data.result);

                        commit("hideMiniLoader");
                        commit("timbratureCaricate", timbrature);
                    }).catch((ex)=>{
                    commit("hideMiniLoader");
                });

            }catch(e){
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX getDettaglioTicket error: "+e.message,
                    messageType:'error'
                });
            }
        },

        async saveNuovaAttivita({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/creaAttivita", {
                    ...data
                },{...config})
                    .then(response=>{
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        if(response.data.responseCode!==200){
                            throw new Error(response.data.dettagli)
                        }
                        let idAdditivitaCreata=response.data.result;

                        let nuovaAttivitaCreata={
                            id_ticket_first_padre:data?.idTicketParent,
                            id_ticket:idAdditivitaCreata,
                            descrizione:data.descrizioneAttivita,
                            titolo:data.titoloAttivita,
                            categoria_ticket_id:data.idTicketCategoria
                        }


                        commit('removeRequest');
                        commit("hideMiniLoader");
                        commit("attivitaCreata", nuovaAttivitaCreata);
                    }).catch((ex)=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                });
                //let attivita=[]
                // dettagli.forEach((att)=>{
                //     if(att.id_ticket_padre>0){
                //         attivita.push(att)
                //     }
                // });
                //commit("hideLoader");

            }catch(e){
                commit('removeRequest');
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX getDettaglioTicket error: "+e.message,
                    messageType:'error'
                });
            }
        },

        creaAttivita({commit}, data){
            commit('creaAttivita',data);
        },
        async loadCategorieTicket({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getCategorieTicket", {},{ adapter: 'fetch', fetchOptions: { priority: 'low' }, ...config})
                    .then(response=>{
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        if(response.data.responseCode!==200){
                            throw new Error(response.data.dettagli)
                        }
                        let result=JSON.parse(response.data.result);
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        commit("categorieTicketLoaded", result);
                    }).catch((ex)=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                });
                //let attivita=[]
                // dettagli.forEach((att)=>{
                //     if(att.id_ticket_padre>0){
                //         attivita.push(att)
                //     }
                // });
                //commit("hideLoader");

            }catch(e){
                commit('removeRequest');
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX getDettaglioTicket error: "+e.message,
                    messageType:'error'
                });
            }
        },

        async loadAttivitaSenzaLavoro({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit('addRequest')
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getAttivita", {},{ adapter: 'fetch', fetchOptions: { priority: 'low' }, ...config})
                    .then(response=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    if(response.data.responseCode!==200){
                        throw new Error(response.data.dettagli)
                    }
                    let result=null;
                    if(response.data.resultObj){
                        result=response.data.resultObj;
                    }else{
                        result=JSON.parse(response.data.result);
                    }
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    commit("attivitaSenzaLavoroCaricate", result);
                }).catch((ex)=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                });
                //let attivita=[]
                // dettagli.forEach((att)=>{
                //     if(att.id_ticket_padre>0){
                //         attivita.push(att)
                //     }
                // });
                //commit("hideLoader");

            }catch(e){
                commit('removeRequest');
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX getDettaglioTicket error: "+e.message,
                    messageType:'error'
                });
            }
        },
        async loadAttivitaLavoro({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
               //commit("showLoader");
               let request= axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getAttivitaLavoro", {
                    idTicket:data.idTicket
                },{ ...config})
                let response=await request;
                if(response.data.responseCode!==200){
                    throw new Error(response.data.dettagli)
                }
                let result=JSON.parse(response.data.result);
                commit("attivitaLavoroCaricate", result);

                // let response= await request;
                // if(response.data.responseCode!==200){
                //     throw new Error(response.data.dettagli)
                // }
                //
                // let dettagli=JSON.parse(response.data.result);

                //let attivita=[]
                // dettagli.forEach((att)=>{
                //     if(att.id_ticket_padre>0){
                //         attivita.push(att)
                //     }
                // });
                //commit("hideLoader");

            }catch(e){
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX getDettaglioTicket error: "+e.message,
                    messageType:'error'
                });
            }
        },

        async loadTutteLeAttivita({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                //commit("showLoader");
                commit('addRequest')
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getAttivitaTutte", {},{ adapter: 'fetch', fetchOptions: { priority: 'low' }, ...config}).then(response=>{
                    if(response.data.responseCode!==200){
                        throw new Error(response.data.dettagli)
                    }
                    let result=null;
                    if(response.data.resultObj){
                        result=response.data.resultObj;
                    }else{
                        result=JSON.parse(response.data.result);
                    }
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    commit("tutteLeAttivitaCaricate", result);
                }).catch((ex)=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    commit('addMessage', {
                        message:"VUEX loadTutteLeAttivita error: "+ex.message,
                        messageType:'error'
                    });
                });

            }catch(e){
                commit('removeRequest');
                commit("hideMiniLoader");
                commit('addMessage', {
                    message:"VUEX loadTutteLeAttivita error: "+e.message,
                    messageType:'error'
                });
            }
        },
        async loadAttivitaUtente({commit}, idUtente){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/getAttivitaForUser", {
                    idAccount:idUtente
                },{  ...config}).then(response=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    if(response.data.responseCode!==200){
                        throw new Error(response.data.dettagli)
                    }
                    let result=null;
                    if(response.data.resultObj){
                        result=response.data.resultObj;
                    }else{
                        result=JSON.parse(response.data.result);
                    }

                    commit("hideMiniLoader");
                    commit("attivitaUtenteLoaded", result);
                }).catch((ex)=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    commit('addMessage', {
                        message:"VUEX loadAttivitaUtente error: "+ex.message,
                        messageType:'error'
                    });
                });

            }catch(e){
                commit('removeRequest');
                commit("hideMiniLoader");
                commit('addMessage', {
                    message:"VUEX loadAttivitaUtente error: "+e.message,
                    messageType:'error'
                });
            }
        },
        async chiudiTicket({commit}, data){
            try{
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/quik/chiudiTicket", {
                    idTicket: data.idTicket,
                    idOwner:data.idOwner,
                    force:data.force,
                    messaggioChiusuraTicket:data.messaggioChiusuraTicket,
                    inviaNotifica:data.inviaNotifica||true,

                },{ ...config}).then(response=>{
                    commit("hideMiniLoader");
                    commit("hideLoader");
                    if(response.data.responseCode!==200){
                        throw new Error(response.data.dettagli)
                    }
                    let result=response.data.result;
                    commit("hideMiniLoader");
                    commit("hideLoader");
                    commit('addMessage', {
                        message:"Ticket chiuso correttamente",
                        messageType:'success'
                    });
                    commit("ticketChiuso", result);
                }).catch((ex)=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    commit('addMessage', {
                        message:"VUEX loadAttivitaUtente error: "+ex.message,
                        messageType:'error'
                    });
                });;
            }catch(e){
                commit("hideMiniLoader");
                commit("hideLoader");
                commit('addMessage', {
                    message:"VUEX chiudiTicket error: "+e.message,
                    messageType:'error'
                });
            }

        }
    },
    getters:{
        getAttivitaSenzaLavoro: (state) => () => {
            if(!state.loadedSenzaLavoro){
                return false
            }

            return [...state.attivitaSenzaLavoro]
        },

        getAttivitaTutte: (state) => () => {

            return [...state.attivitaSenzaLavoro, ...state.attivita]
        },

        getAttivitaLavoro: (state) => (idTicket) => {
            if(!state.loaded){
                return false
            }
            let filtrati=[...state.attivita.filter(att=>att.id_ticket_first_padre==idTicket)];
            return [...filtrati]
        },

        getTicket: (state) => (idTicket) => {
            if(!state.loaded){
                return false
            }
//            console.log("searching for ",idTicket," in ",state.attivita);
            let filtrati=[...state.attivita.filter(att=>att.id_ticket==idTicket)];
            if(filtrati.length==0){
                filtrati=[...state.attivitaSenzaLavoro.filter(att=>att.id_ticket==idTicket)];
            }
            return [...filtrati]
        }
    }
}

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

export {AttivitaStore};